
import api from "../../../utilidades/interceptor";

const apiKey = process.env.REACT_APP_API_KEY


export const getUnidades = async (setDatatable) => {
    await api.get(`${apiKey}/operaciones/getUnidadesActivas`).then((res) => {
        setDatatable(res.data)
    })
        .catch((error) => {
            console.log("error", error);
        })
}

export const getOperadoresDisponibles = (setOperandores) => {
    api.get(`${apiKey}/operaciones/getOperadoresDisponibles`).then((res) => {

        setOperandores(res.data)
    })
        .catch((error) => {
            console.log("error", error);
        })
}

export const getUnidadesDisponibles = (setOperandores) => {
    api.get(`${apiKey}/operaciones/getUnidadesDisponibles`).then((res) => {

        setOperandores(res.data)
    })
        .catch((error) => {
            console.log("error", error);
        })
}
export const desvincularDB = (id_operador, id_unidad, setActualizar, actualizar) => {
    const request = {
        id_operador,
        id_unidad
    }
    api.put(`${apiKey}/operaciones/desvincularOperador`, request).then((res) => {
        setActualizar(!actualizar)
    })
        .catch((error) => {
            console.log("error", error);
        })
}
export const asignarUnidad = (id_operador, id_unidad, setActualizar, actualizar, estatus = null) => {
    const request = {
        id_operador,
        id_unidad,
        estatus
    }
    return api.put(`${apiKey}/operaciones/asignarUnidad`, request).then((res) => {
        setActualizar(!actualizar)
    })
        .catch((error) => {
            console.log("error", error);
        })
}

export const ESTATUS_EMPRESARIAL = 1;

export const desvincularOperadoresInactivos = async () => {
    try {
        await api.put(`${apiKey}/operaciones/desvincularOperadoresInactivos`);
    } catch (error) {
        console.error("Error al desvincular operadores inactivos:", error);
        throw error;
    }
};